"use client";
import { cn } from "@/lib/utils";
import { useActiveSection } from "./hooks";

interface IndustryNavProps {
  ariaLabel: string;
  items: { id: string; label: string }[];
}

// Sticky in-page jump links to each industry, highlighting the one being
// read. One line that scrolls sideways on narrow phones.
const IndustryNav = ({ ariaLabel, items }: IndustryNavProps) => {
  const activeId = useActiveSection(items.map((item) => item.id));

  return (
    <nav
      aria-label={ariaLabel}
      className="sticky top-[80px] z-20 mx-auto mb-[26px] w-fit max-w-full overflow-x-auto rounded-[22px] bg-white/90 p-2 shadow-card backdrop-blur-md [scrollbar-width:none] sm:rounded-full [&::-webkit-scrollbar]:hidden"
    >
      <ul className="flex w-max gap-2">
        {items.map((item) => {
          const isActive = item.id === activeId;
          return (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                aria-current={isActive ? "location" : undefined}
                className={cn(
                  "block rounded-full px-4 py-2 text-[14.5px] font-bold whitespace-nowrap transition-colors",
                  isActive
                    ? "bg-primary text-white"
                    : "text-ink-muted hover:bg-paper hover:text-ink",
                )}
              >
                {item.label}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default IndustryNav;
